var _Fragment2, _Glyphicon;
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Button, Glyphicon, Text } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import clsx from 'clsx';

/**
 *  The OneClickButton component contains the button to send email to dealers within One-Click experience
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function OneClickButton(_ref) {
  let {
    handleEditSettingsClick = () => {},
    handleEmailSendClick = () => {},
    hideModifySettings = false,
    listingId,
    isFullSize,
    isModifySettingsIcon = true,
    oneClickEmailSent = false,
    wrapperClassNames = ''
  } = _ref;
  const handleEditSettings = useCallback(event => {
    handleEditSettingsClick(event);
    sendClick('oneClickButtonClick', event, {
      listingId,
      element: 'cta',
      content: 'edit'
    });
  }, [handleEditSettingsClick, listingId]);
  const buttonsize = isFullSize ? '' : 'small';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: wrapperClassNames,
      children: /*#__PURE__*/_jsxs(Button, {
        block: true,
        bsSize: buttonsize,
        bsStyle: isModifySettingsIcon ? 'default' : 'primary',
        className: "display-flex justify-content-center align-items-center",
        "data-cmp": "btn-oneClick",
        onClick: handleEmailSendClick,
        disabled: oneClickEmailSent && !isModifySettingsIcon,
        children: [oneClickEmailSent && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Glyphicon, {
            "aria-hidden": "true",
            className: clsx('text-size-400 margin-right-2', {
              'text-success': isModifySettingsIcon
            }),
            glyph: "success"
          }), /*#__PURE__*/_jsx(Text, {
            color: isModifySettingsIcon ? 'success' : undefined,
            children: "Email Sent"
          })]
        }), !oneClickEmailSent && (_Fragment2 || (_Fragment2 = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Glyphicon, {
            "aria-hidden": "true",
            className: "text-size-400 margin-right-2",
            glyph: "electric"
          }), "Send Email to Dealer"]
        })))]
      })
    }), isModifySettingsIcon && !hideModifySettings && /*#__PURE__*/_jsx(Button, {
      "aria-label": "Edit Your One-Click Email Settings",
      bsStyle: "default",
      bsSize: "small",
      onClick: handleEditSettings,
      children: _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "edit",
        "aria-hidden": "true",
        className: "text-size-400"
      }))
    }), !isModifySettingsIcon && !hideModifySettings && /*#__PURE__*/_jsx(Button, {
      bsStyle: "text",
      className: "display-block margin-top-3 text-center",
      onClick: handleEditSettings,
      children: "Modify Settings"
    })]
  });
}
export default OneClickButton;